import React from 'react'
import axios from '@/utils/myAxios'
import myUploadAxios from '@/utils/myUploadAxios'
import moment from 'moment'
import Cookie from "js-cookie";
import { Link } from 'react-router-dom'
import { statusList1 } from '@/utils/constant'
import { tableSummaries, isMobileDevice, imgCompress } from '@/utils/utils'
import {
    Input,
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    Icon,
    Form,
    DatePicker,
    Upload,
    InputNumber,
    Radio,
} from 'antd'

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf('day')
}

// 表单数据
const formData = {
    uri: undefined,
    icon_uri: undefined,
    date_range: [],
    link_url: undefined,
    order_num: undefined,
    show: 0,
}

export default class ActivityPoster extends React.Component {
    state = {
        uploadCoverLoading: false, // 上传封面是否加载中
        uploadIconLoading: false, // 上传小图是否加载中
        loading: false, // 是否加载中
        show: false, // 新增弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined
        },
        statusList: statusList1, // 状态列表
        data: [], // 表格数据
        formData: { ...formData }, // 表单数据
        uploadFile: {}, // 上传的文件
        channelList: [
            // 渠道列表
            { name: this.props.language['allVersion'], id: 0 },
        ],
        selectedData: {}, // 选中的表格数据
    };

    componentDidMount () {
        this.fetchData()
        this.fetchChannelList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/union_banner_list', {
                params: {
                    ...this.state.queryParams,
                    status:
                        this.state.queryParams.status !== undefined
                            ? this.state.queryParams.status
                            : -1,
                    total: undefined
                }
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || []
                })
            })
    };

    /**
     * 获取渠道列表
     */
    fetchChannelList = () => {
        axios
            .get('/v1/api/support/channel_list')
            .then((res) => {
                this.setState({
                    channelList: this.state.channelList.concat(res.data || [])
                })
            })
    };

    /**
     * 新增、编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/union_banner_add', {
                        id: this.state.type === 'edit' ? this.state.selectedData.id : undefined,
                        uri: values.uri,
                        icon_uri: values.icon_uri,
                        begin_at: parseInt(new Date(values.date_range[0]).getTime() / 1000),
                        end_at: parseInt(new Date(values.date_range[1]).getTime() / 1000),
                        link_url: values.link_url,
                        order_num: values.order_num,
                        show: values.show,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            if (this.state.type === 'edit') {
                                message.success(this.props.language["editSuccessMessage"])
                            } else {
                                message.success(this.props.language["createSuccessMessage"])
                            }
                            this.fetchData()
                            this.handleClose()
                        }
                    })
            }
        })
    };

    /**
     * 发布、下线、删除
     */
    handleOperation = (type, item) => {
        let action, title, content
        switch (type) {
            case 'publish':
                action = 1
                title = this.props.language["publishSuccessMessage"]
                content = this.props.language["publishConfirm"]
                break
            case 'offline':
                action = 2
                title = this.props.language["offlineSuccessMessage"]
                content = this.props.language["offlineConfirm"]
                break
            case 'delete':
                action = 3
                title = this.props.language["deleteSuccessMessage"]
                content = this.props.language["deleteConfirm"]
                break
        }
        Modal.confirm({
            title: this.props.language["hint"],
            content: content,
            onOk: () => {
                axios
                    .patch('/v1/api/union_banner_set', { id: item.id, action })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(title)
                            this.fetchData()
                        }
                    })
            }
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['createPoster'],
            })
        } else if (type === 'edit') {
            // 编辑
            this.setState({
                type,
                show: true,
                title: this.props.language['editPoster'],
                formData: {
                    uri: item.uri,
                    icon_uri: item.icon_uri,
                    date_range: [moment(item.begin_at), moment(item.end_at)],
                    link_url: item.link_url,
                    order_num: item.order_num,
                    show: item.show,
                },
                selectedData: { ...item },
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false });
        this.setState({ show: false, formData: { ...formData } });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize
                }
            },
            () => this.fetchData()
        )
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value }
        })
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined
                }
            },
            () => {
                this.fetchData()
            }
        )
    };

    /**
     * 上传图片
     */
    handleUploadImg = ({ file }, key) => {
        key === 'uri' ? this.setState({ uploadCoverLoading: true }) : this.setState({ uploadIconLoading: true })
        imgCompress(file, (compressedFile) => {
            myUploadAxios.post('/v1/api/upload/s3', { path: 'cms/banner', file: compressedFile }).then((res) => {
                if (res.code === 200) {
                    this.setState({ uploadFile: file })
                    this.formRef.props.form.setFieldsValue({ [key]: res.data })
                }
                key === 'uri' ? this.setState({ uploadCoverLoading: false }) : this.setState({ uploadIconLoading: false })
            })
        })
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData('status', value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    {(Cookie.get("identityType") === "super_union" ||
                        Cookie.get("identityType") === "super_union_vip" ||
                        Cookie.get("identityType") === "super_union_admin_finance" ||
                        Cookie.get("identityType") === "super_union_admin_management") && (
                            <Button type="primary" ghost onClick={() => this.handleShow('add')}>
                                {this.props.language["createPoster"]}
                            </Button>
                        )}
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column
                            align="center"
                            title={this.props.language["poster"]}
                            dataIndex=""
                            render={(item) => (
                                <img
                                    src={process.env.REACT_APP_IMG_CDN + item.uri}
                                    style={{ height: '120px', borderRadius: '5px' }}
                                />
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["thumbnail"]}
                            dataIndex=""
                            render={(item) => (
                                <img
                                    src={process.env.REACT_APP_IMG_CDN + item.icon_uri}
                                    style={{ height: '60px', borderRadius: '5px' }}
                                />
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (item2) => item2.value == item.status
                                ) ?
                                    this.state.statusList.find(
                                        (item2) => item2.value == item.status
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["posterSort"]}
                            dataIndex="order_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['showType']}
                            dataIndex=""
                            render={(item) =>
                                this.state.channelList.find(
                                    (item2) => item2.id === item.show
                                ) ?
                                    this.state.channelList.find(
                                        (item2) => item2.id === item.show
                                    ).name
                                    : ''
                            }
                        />

                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["posterLinkUrl"]}
                            dataIndex="link_url"
                        />
                        {(Cookie.get("identityType") === "super_union" ||
                            Cookie.get("identityType") === "super_union_vip" ||
                            Cookie.get("identityType") === "super_union_admin_finance" ||
                            Cookie.get("identityType") === "super_union_admin_management") && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["operation"]}
                                    dataIndex=""
                                    fixed={isMobileDevice() ? false : 'right'}
                                    width={260}
                                    render={(item) => (
                                        <>
                                            <Button
                                                className="ml10"
                                                type="primary"
                                                ghost
                                                onClick={() => this.handleShow('edit', item)}
                                            >
                                                {this.props.language["edit"]}
                                            </Button>
                                            {item.status === 0 &&
                                                <Button
                                                    className="ml10 btn-green-ghost"
                                                    onClick={() => this.handleOperation('publish', item)}
                                                >
                                                    {this.props.language["publish"]}
                                                </Button>
                                            }
                                            {item.status !== 0 &&
                                                <Button
                                                    className="ml10 btn-yellow-ghost"
                                                    ghost
                                                    onClick={() => this.handleOperation('offline', item)}
                                                >
                                                    {this.props.language["offLine"]}
                                                </Button>
                                            }
                                            <Button
                                                className="ml10"
                                                type="danger"
                                                ghost
                                                onClick={() => this.handleOperation('delete', item)}
                                            >
                                                {this.props.language["delete"]}
                                            </Button>
                                        </>
                                    )}
                                />
                            )}
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    formData={this.state.formData}
                    channelList={this.state.channelList}
                    uploadCoverLoading={this.state.uploadCoverLoading}
                    uploadIconLoading={this.state.uploadIconLoading}
                    handleUploadImg={this.handleUploadImg}
                    onOk={this.handleAddOrEdit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        /**
         * 上传前
         */
        MAX_SIZE = 1 // 最大上传大小限制
        beforeUpload = (file) => {
            const acceptList = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
            const isAcceptedType = acceptList.includes(file.type)
            if (!isAcceptedType) {
                message.error(this.props.getLanguage("uploadeTypeMessage", 'PNG/JPG/JPEG/GIF'))
                return false
            }
            const isAcceptedLimit = file.size / 1024 / 1024 < this.MAX_SIZE
            if (!isAcceptedLimit) {
                message.error(this.props.getLanguage("uploadeSizeMessage", this.MAX_SIZE))
                return false
            }
            return true
        };

        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["posterImage"]}>
                                {getFieldDecorator('uri', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["posterImageVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.uri
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".png,.jpg,.jpeg,.gif"
                                            listType="picture-card"
                                            disabled={this.props.uploadCoverLoading}
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={(file) => this.props.handleUploadImg(file, 'uri')}
                                        >
                                            {getFieldValue('uri') && !this.props.uploadCoverLoading ? (
                                                <img
                                                    src={
                                                        process.env.REACT_APP_IMG_CDN + getFieldValue('uri')
                                                    }
                                                    alt="avatar"
                                                    style={{ height: '120px' }}
                                                />
                                            ) : (
                                                <div>
                                                    <Icon
                                                        type={this.props.uploadCoverLoading ? 'loading' : 'plus'}
                                                    />
                                                    <p className="ant-upload-text">Upload</p>
                                                </div>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                marginTop: '-20px',
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.getLanguage("suggestHeightWidth", 950, 1500)} </p>
                                            <div style={{ marginTop: '-15px' }}>
                                                <p>{this.props.getLanguage("suggestSize", this.MAX_SIZE)} </p>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["thumbnail"]}>
                                {getFieldDecorator('icon_uri', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["thumbnailVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.icon_uri
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".png,.jpg,.jpeg,.gif"
                                            listType="picture-card"
                                            disabled={this.props.uploadIconLoading}
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={(file) => this.props.handleUploadImg(file, 'icon_uri')}
                                        >
                                            {getFieldValue('icon_uri') && !this.props.uploadIconLoading ? (
                                                <img
                                                    src={
                                                        process.env.REACT_APP_IMG_CDN + getFieldValue('icon_uri')
                                                    }
                                                    alt="avatar"
                                                    style={{ height: '60px' }}
                                                />
                                            ) : (
                                                <div>
                                                    <Icon
                                                        type={this.props.uploadIconLoading ? 'loading' : 'plus'}
                                                    />
                                                    <p className="ant-upload-text">Upload</p>
                                                </div>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                marginTop: '-20px',
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.getLanguage("suggestHeightWidth", 1000, 170)} </p>
                                            <div style={{ marginTop: '-15px' }}>
                                                <p>{this.props.getLanguage("suggestSize", this.MAX_SIZE)} </p>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["timeRange"]}>
                                {getFieldDecorator('date_range', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["timeRangeVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.date_range
                                })(
                                    <DatePicker.RangePicker
                                        disabledDate={disabledDate}
                                        showTime={{ format: 'HH:mm' }}
                                        format="YYYY-MM-DD HH:mm"
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["showType"]}>
                                {getFieldDecorator('show', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["showTypeVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.show
                                })(
                                    <Radio.Group >
                                        {this.props.channelList.map(
                                            (item, index) => (
                                                <Radio
                                                    key={index}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["posterSort"]}>
                                {getFieldDecorator('order_num', {
                                    rules: [
                                        {
                                            required: false,
                                            message: this.props.language["posterSortVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.order_num
                                })(
                                    <InputNumber
                                        precision={0}
                                        min={0}
                                        max={999}
                                        placeholder={this.props.language["posterSortPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["posterLinkUrl"]}>
                                {getFieldDecorator('link_url', {
                                    rules: [
                                        {
                                            required: false,
                                            message: this.props.language["posterLinkUrlVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.link_url
                                })(
                                    <Input
                                        maxLength={60}
                                        allowClear
                                        placeholder={this.props.language["posterLinkUrlPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
